// import Table from "react-bootstrap/Table";
// import Button from "react-bootstrap/Button";
import React from 'react';

import Filters from './Filters';
import TableGames from './TableGames';
import { useRouter } from '../../../../helpers/customHooks';
import { useDataPlayersState } from '../../../../store/hooks';
import { PlayerRoutes } from '../../types';
import { DataPlayer } from '../../../../store/types';

export default () => {
  const { match } = useRouter<PlayerRoutes>();
  const { dataPlayer } = useDataPlayersState(match.params.playerId);
  
  return (<>
    <Filters player={(dataPlayer as DataPlayer).meta} />
    <div className="games-body">
      <TableGames />
    </div>
  </>);
};
